export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-yen-10a4ea4e2584599503fe08bdccbd1f4b.svg";